import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { RequireCapability } from "@/features/account/RequireCapability";
import { NotFoundPage } from "@/features/errors/NotFoundPage";
import { TeamPage } from "@/features/teams/TeamPage";
import { AiPreferencesPage } from "./ai/AiPreferencesPage";
import { AppearancePage } from "./appearance/AppearancePage";
import { AuthorizationsPage } from "./authorizations/AuthorizationsPage";
import { ConnectionsPage } from "./connections/ConnectionsPage";
import { MemoryPage } from "./memory/MemoryPage";
import { NotificationsPage } from "./notifications/NotificationsPage";
import { ProfilePage } from "./profile/ProfilePage";
import { RallyPage } from "./rally/RallyPage";
import { NewApiKeyPage } from "./security/NewApiKeyPage";
import { SecurityPage } from "./security/SecurityPage";
import { SETTINGS_SECTION_CAPABILITY } from "./settingsNav";
import { TeamsPage } from "./teams/TeamsPage";
import { UsagePage } from "./usage/UsagePage";

export const settingsRoutes: RouteObject[] = [
  { index: true, element: <ProfilePage /> },
  { path: "appearance", element: <AppearancePage /> },
  { path: "ai", element: <AiPreferencesPage /> },
  {
    path: "memory",
    element: (
      <RequireCapability capability={SETTINGS_SECTION_CAPABILITY.memory}>
        <MemoryPage />
      </RequireCapability>
    ),
  },
  { path: "notifications", element: <NotificationsPage /> },
  { path: "security", element: <SecurityPage /> },
  { path: "security/api-keys/new", element: <NewApiKeyPage /> },
  { path: "connections", element: <ConnectionsPage /> },
  // Extension consent moved into Connections (phase 7).
  { path: "extensions", element: <Navigate to="/settings/connections" replace /> },
  {
    path: "authorizations",
    element: (
      <RequireCapability capability={SETTINGS_SECTION_CAPABILITY.authorizations}>
        <AuthorizationsPage />
      </RequireCapability>
    ),
  },
  {
    path: "rally",
    element: (
      <RequireCapability capability={SETTINGS_SECTION_CAPABILITY.rally}>
        <RallyPage />
      </RequireCapability>
    ),
  },
  { path: "usage", element: <UsagePage /> },
  { path: "teams", element: <TeamsPage /> },
  { path: "teams/:teamUuid", element: <TeamPage from="settings" /> },
  { path: "*", element: <NotFoundPage /> },
];
